export interface EmailTypeDetectionConfig {
  description: string
  aiAssistantInstructions: string
}

export enum EmailTypeKind {
  REPLY = 'reply',
  NEW = 'new',
}

interface BaseEmailType {
  id: string
  name: string
  isActive: boolean
  detectionConfig: EmailTypeDetectionConfig
  systemEmailTypeId?: string
  metadata: { [key: string]: any }
}

interface ReplyEmailType extends BaseEmailType {
  kind: EmailTypeKind.REPLY
  roleIds: string[]
}

interface NewEmailType extends BaseEmailType {
  kind: EmailTypeKind.NEW
}

export type EmailType = ReplyEmailType | NewEmailType
